import React from "react";
import { VEHICLE_STATUS_LABELS, VEHICLE_STATUS_COLOR } from "@/lib/labels";

/**
 * Badge disponibilità veicolo.
 * status: VIRTUAL | INCOMING | AVAILABLE | RESERVED | SOLD | DELIVERED
 */
export default function DisponibilitaBadge({ status, size = "md" }) {
  if (!status) return null;
  const label = VEHICLE_STATUS_LABELS[status] || status;
  const color = VEHICLE_STATUS_COLOR[status] || "bg-slate-100 text-slate-700 border-slate-200";
  const px = size === "sm" ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-1 text-xs";
  return (
    <span
      className={`inline-flex items-center font-medium rounded-full border ${color} ${px}`}
      data-testid={`disponibilita-badge-${status}`}
    >
      {label}
    </span>
  );
}
